function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "noun_1136236_cc@svg");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null);

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "iphone-8",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "noun_1136236_cc",
  fill: "#80A1FE",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M63.9,22.2 C63.9,23.9 62.5,25.3 60.8,25.3 L47.7,25.3 C45.3,33.4 37.7,39.4 28.8,39.4 L13.6,39.4 L48.8,69 C50.5,70.4 50,72.4 47.7,73.4 C46.8,73.8 45.7,74 44.7,74 C43.2,74 41.6,73.6 40.6,72.7 L1.1,39.5 C1.1,39.5 1,39.4 1,39.4 C0.2,38.7 -0.1,37.8 0.2,37 C0.1,36.8 0.1,36.5 0.1,36.2 C0.1,34.5 1.5,33.1 3.2,33.1 L28.8,33.1 C34.2,33.1 38.8,29.9 41,25.3 L3.2,25.3 C1.5,25.3 0.1,23.9 0.1,22.2 C0.1,20.5 1.5,19.1 3.2,19.1 L42.2,19.1 C41.9,12 36,6.3 28.8,6.3 L3.2,6.3 C1.5,6.3 0.1,4.9 0.1,3.2 C0.1,1.5 1.5,0.1 3.2,0.1 L60.7,0.1 C62.4,0.1 63.8,1.5 63.8,3.2 C63.8,4.9 62.4,6.3 60.7,6.3 L43.2,6.3 C46.3,9.7 48.3,14.1 48.5,19.1 L60.8,19.1 C62.5,19.1 63.9,20.5 63.9,22.2 Z",
  id: "Shape"
})));

var SvgInr = function SvgInr(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "74px",
    viewBox: "0 0 64 74",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInr, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/inr.8bfec66e.svg";
export { ForwardRef as ReactComponent };